var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag_item fs12 mr6 Text_Over",class:{action: !_vm.disabled},style:({
        color: _vm.item.color, 
        borderColor: _vm.solidColorBag ? '#fff' : _vm.$utils.hexToRgb(_vm.item.color, _vm.hover ? 1 : 0.5),
        background: _vm.solidColorBag ? '#fff' : _vm.$utils.hexToRgb(_vm.item.color, _vm.hover ? 1 : 0.3),
        height:_vm.height,
        lineHeight:_vm.height
    }),attrs:{"title":_vm.item.name},on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_vm._v(" "+_vm._s(_vm.item.name)+" "),_c('span',{staticClass:"el-icon-close close",on:{"click":function($event){$event.stopPropagation();return _vm.deleteFn.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }